import { render, staticRenderFns } from "./AICTAModal.vue?vue&type=template&id=674b9c19&"
import script from "./AICTAModal.vue?vue&type=script&lang=js&"
export * from "./AICTAModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports